module.exports = "https://preprod.web-phone.apps.phone.com/static/media/dtmf-7.ba927e1a.mp3";